import { react } from "react";
import image1 from "../assets/images/home/home-author-image.png";

const Introduction = () => {
    return (
        <div className="newspaper-container-wrapper">
            <div className="container pt-5 pb-3 pb-lg-4">
                <div className="row">
                    <h2 className="author-section-title">संपादक एवं प्रकाशक</h2>
                    <div className="col-lg-5 col-md-5 col-12 ps-0 pe-0 pe-lg-2">
                        <div className="author-image-intro-wrapper">
                            <img src={image1} alt="Author" className="author-image mb-3" />
                            <h3>संपादक एवं प्रकाशक</h3>
                            <h3>श्री अतुल वी.एन. चतुर्वेदी</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-7 col-12 pe-0 ps-0 ps-lg-2">
                        <div className="author-content-1">
                            <h4>परिचय</h4>
                            <p>
                                श्री अतुल वी.एन. चतुर्वेदी एक बहुआयामी व्यक्तित्व के धनी हैं, जिनकी गहरी
                                रुचि आम जनमानस की आवाज़ बनने और समाज के वंचित वर्गों के हितों की
                                पैरवी करने में रही है।
                            </p>

                            <h4>शिक्षा</h4>
                            <ul>
                                <li>प्राइमरी शिक्षा – रेजिडेंशियल पब्लिक स्कूल, राजकुमार कॉलेज, राजकोट (गुजरात)</li>
                                <li>ग्रेजुएशन – छत्रपति शिवाजी विश्वविद्यालय, कानपुर</li>
                                <li>पोस्ट ग्रेजुएट डिप्लोमा इन मास कम्युनिकेशन – श्रीधर यूनिवर्सिटी, पिलानी (राजस्थान)</li>
                            </ul>

                            <h4>मीडिया करियर</h4>
                            <p>
                                श्री अतुल वी.एन. चतुर्वेदी ने राष्ट्रीय राजधानी दिल्ली से प्रकाशित दैनिक
                                समाचार पत्र "पब्लिक एशिया" से अपने मीडिया करियर की शुरुआत की।
                            </p>
                            <br />
                            <br /> 
                        </div>
                    </div>
                </div>

                <div className="row mb-4">
                    <div className="col-lg-12 col-md-12 col-12 px-0">
                        <div className="author-content-2">
                           <p> 
                                इसके बाद उन्होंने कई प्रतिष्ठित समाचार पत्रों और मीडिया संस्थानों में
                                योगदान दिया, जैसे:
                            </p>
                            <div className="media-institutions-wrapper">
                                <ul>
                                    <li>टाइम्स ऑफ इंडिया</li>
                                    <li>कुबेर टाइम्स</li>
                                    <li>नॉर्दर्न इंडिया टाइम्स</li>
                                    <li>राष्ट्रीय स्वरूप</li>
                                </ul>
                                <ul>
                                    <li>मीडिया मंच</li>
                                    <li>एसोसिएटेड प्रेस (AP)</li>
                                    <li>NDTV</li>
                                    <li>राज्य सभा टीवी</li>
                                </ul>
                            </div>

	                    <h4>सम्मान एवं पुरस्कार</h4>
                            <ul>
                                <li>वैश्विक हिंदी संस्थान जर्मनी द्वारा प्रज्ञान विश्वम सम्मान, प्रेस क्लब ऑफ़ इंडिया नई दिल्ली</li>
                                <li>अखिल भारतीय हिंदी पत्रकार संघ द्वारा कृष्ण बिहारी श्रीवास्तव रंग भारती सम्मान, बौद्ध शोध संस्थान गोमती नगर लखनऊ</li>
                                <li>राष्ट्रीय नवरत्न सम्मान – विज्ञान भवन, नई दिल्ली</li>
                                <li>पंडित बनारसी दास चतुर्वेदी स्मृति सम्मान – लेखक गांव, देहरादून</li>
                                <li>राष्ट्रीय गौरव सम्मान – चौधरी चरण सिंह विश्वविद्यालय, मेरठ</li>
                            </ul>
                            <p>
                                वर्ष 2007 से वे राष्ट्रीय चैनल दूरदर्शन समाचार के लिए कार्य कर रहे हैं।
                            </p>

                            <h4>संपादन कार्य</h4>
                            <p>
                                नागा उद्गार, समाज दर्पण और इटावा टाइम्स।
                            </p>
                            <h4>सदस्यता</h4>
                            <ul>
                                <li>कार्यकारी अध्यक्ष – उत्तर प्रदेश वर्किंग जर्नलिस्ट यूनियन, इटावा</li>
                                <li>कार्यकारिणी सदस्य – दूरदर्शन स्ट्रिंगर फेडरेशन ऑफ इंडिया</li>
                                <li>आजीवन सदस्य – रेड क्रॉस सोसाइटी ऑफ इंडिया</li>
                                <li>गवर्निंग बॉडी सदस्य – श्री माथुर चतुर्वेदी महापरिषद</li>
                            </ul>

                            <h3>इटावा के बारे में</h3>
                            <p>
                                इटावा उत्तर प्रदेश राज्य में यमुना नदी के तट पर स्थित एक प्रमुख शहर है। यह इटावा जिले का प्रशासनिक मुख्यालय है। वर्ष 1857 के विद्रोह के दौरान यह शहर एक महत्वपूर्ण केंद्र रहा था (उस समय Allan Octavian Hume जिला कलेक्टर थे)।
                            </p>
                            <p>
                                यह स्थान यमुना और चंबल नदियों के संगम के लिए भी प्रसिद्ध है। यहाँ “ग्रेट हेज ऑफ इंडिया” के अवशेष भी पाए जाते हैं। प्रसिद्ध हिंदी साहित्यकार Gulabrai का जन्म भी इटावा में हुआ था।
                            </p>
                            <p>
                                इटावा का इतिहास समृद्ध और गौरवशाली रहा है। माना जाता है कि यह क्षेत्र कांस्य युग से ही अस्तित्व में रहा है। यहाँ आर्य जाति के प्रारंभिक निवासी पंचाल कहलाते थे।
                            </p>
                            <p>
                                पौराणिक ग्रंथों में भी इटावा का उल्लेख महाभारत और रामायण की कथाओं में प्रमुखता से मिलता है। चौथी शताब्दी ईस्वी में यह क्षेत्र गुप्त वंश के अधीन रहा। 1857 के स्वतंत्रता संग्राम के दौरान इटावा एक सक्रिय केंद्र रहा, जहाँ अनेक स्वतंत्रता सेनानी ब्रिटिश शासन के विरुद्ध संघर्षरत थे।
                            </p>
                            <p>
                                आज भी इटावा नगर में “ग्रेट हेज ऑफ इंडिया” के कुछ अवशेष मौजूद हैं, जो ब्रिटिश शासन द्वारा स्थापित एक आंतरिक कर-रेखा थी। माना जाता है कि “इटावा” नाम ईंट बनाने वालों के लिए प्रयुक्त शब्द से निकला है, क्योंकि इसकी सीमाओं के आसपास हजारों ईंट भट्ठे स्थित हैं।
                            </p>
                            <p>
                                इटावा की सीमाएँ आगरा, मैनपुरी और औरैया जिलों से मिलती हैं। यहाँ का भू-भाग चंबल और यमुना नदियों द्वारा निर्मित गहरी घाटियों (बीहड़ों) से युक्त है।
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );

};

export default Introduction;

